import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { reasons } from './servicesData';
import StarredImage from './StarredImage';
import chooseImage from '../../../assets/images/choose-image.png';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';

const WhyChooseUs: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section className="">
      <div className="section-gap-lg why-choose-us" data-aos="fade-up">
        <Container className="choose-container">
          <Row className="choose-row">
            <Col lg={12} className="">
              <div className="choose-content text-center text-md-start" data-aos="fade-up">
                <div>
                  <h2 className="choose-title">Why Choose Us ?</h2>
                  <p className="choose-subtitle">
                    Partner with Legalligence for smart legal solutions, insights, and AI-driven
                    accuracy.
                  </p>
                </div>
                <div className="why-choose-btn">
                  <Button label={'Know More'} onClick={() => navigate('/about')} />
                </div>
              </div>
            </Col>
            <Row className="justify-content-between w-100 mx-0 choose-list">
              <Col lg={6} className="image-section p-0 order-1 order-lg-2" data-aos="fade-left">
                <StarredImage imageSrc={chooseImage} starPosition="left" />
              </Col>
              <Col lg={5} className="p-0 order-2 order-lg-1">
                <div className="features-list" data-aos="fade-right">
                  {reasons.map((feature, index) => (
                    <div className="feature-item" key={index}>
                      <div className="feature-content">
                        <div className="feature-icon">
                          <img src={feature.icon} alt="Service Icon" className="icon" />
                        </div>
                        <div className="feature-text">
                          <p className="feature-description">{feature.text}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default WhyChooseUs;
